import { EditFilled } from "@ant-design/icons";
import { Button, Col, InputNumber, message, Modal, Row, Space } from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import { useHasEditPermission } from "../../../common/hooks";

function PriceModal() {
  const [pricePerMin, setPricePerMin] = useState(0);
  const [updatedPPMin, setUpdatedPPMin] = useState(0);
  const [initialD, setInitialD] = useState(0);
  const [updatedInitialD, setUpdatedInitialD] = useState(0);
  const [initialP, setInitialP] = useState(0);
  const [updatedInitialP, setUpdatedInitialP] = useState(0);
  const [data, setData] = useState([]);
  const [updatedData, setUpdatedData] = useState(null);
  const allowEdit = useHasEditPermission();

  const getPricing = async () => {
    let res = await apiRequest({
      path: apiPaths.constants + "/pricing_model",
    });
    if (!res.error) {
      setData(res.value?.ranges || []);
      setPricePerMin(res.value?.price_per_min || 0);
      setInitialD(res.value?.initial_duration || 0);
      setInitialP(res.value?.initial_price|| 0);
    }
  };

  useEffect(() => {
    getPricing();
  }, []);

  const handleUpdate = async () => {
    let res = await apiRequest({
      path: apiPaths.constants + "/pricing_model",
      method: "PUT",
      data: {
        value: {
          ranges: updatedData,
          price_per_min: updatedPPMin,
          initial_duration: updatedInitialD,
          initial_price: updatedInitialP,
        },
      },
    });

    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setData([...updatedData]);
    setPricePerMin(updatedPPMin);
    setInitialD(updatedInitialD)
    setInitialP(updatedInitialP)
    setUpdatedData(null);
  };

  return (
    <div style={{ width: 300, padding: 20 }}>
      <div
        style={{
          display: "flex",
          marginBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontSize: 20 }}>Pricing Model</div>
        {allowEdit ? (
          <Button
            type="link"
            onClick={() => {
              setUpdatedPPMin(pricePerMin);
              setUpdatedData([...data]);
              setUpdatedInitialD(initialD)
              setUpdatedInitialP(initialP)
            }}
          >
            <EditFilled />
          </Button>
        ) : null}
      </div>
      <div style={{ border: "1px solid #b7b7b750" }}>
      <Row
          style={{
            padding: 5,
          }}
          key={"s"}
        >
          <Col span={12} style={{ padding: 5 }}>
            {`For first ${initialD} min`}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {`${initialP} total`}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b750",
          }}
        >
          <Col span={12} style={{ fontWeight: "bold", padding: 5 }}>
            {"Duration"}
          </Col>
          <Col
            span={12}
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #b7b7b730",
              padding: 5,
            }}
          >
            {"price / min"}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={"s"}
        >
          <Col span={12} style={{ padding: 5 }}>
            {`next ${data[0]?.duration} min`}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data[0]?.price}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={"idx"}
        >
          <Col span={12} style={{ padding: 5 }}>
            {`for next ${data[1]?.duration} min`}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data[1]?.price}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={3}
        >
          <Col span={12} style={{ padding: 5 }}>
            {`> ${data[0]?.duration + data[1]?.duration} min`}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {pricePerMin}
          </Col>
        </Row>
      </div>

      {updatedData ? (
        <Modal
          title={"Update Pricing"}
          centered
          width={500}
          visible={true}
          onCancel={() => {
            setUpdatedData(null);
          }}
          footer={null}
        >
          <Row gutter={[12, 12]} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <Space>
                <div>{"For first "}</div>
                <InputNumber
                  style={{ width: 100 }}
                  value={updatedInitialD}
                  onChange={setUpdatedInitialD}
                />
                <div>{"min"}</div>
              </Space>
            </Col>
            <Col span={12}>
            <Space>
              <InputNumber
                style={{ width: 100 }}
                value={updatedInitialP}
                onChange={setUpdatedInitialP}
              />
                <div>{"total"}</div>
            </Space>
            </Col>
          </Row>
          <Row gutter={[12, 12]}>
            <Col span={12} style={{ fontWeight: "bold" }}>
              {"Duration"}
            </Col>
            <Col span={12} style={{ fontWeight: "bold" }}>
              {"price / min"}
            </Col>
          </Row>
          <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
            <Col span={12}>
              <Space>
                <div>{"next "}</div>
                <InputNumber
                  style={{ width: 100 }}
                  value={updatedData[0]?.duration}
                  onChange={(value) => {
                    let newData = [...updatedData];
                    newData[0] = {
                      ...newData[0],
                      duration: value,
                    };
                    setUpdatedData(newData);
                  }}
                />
                <div>{"min"}</div>
              </Space>
            </Col>
            <Col span={12}>
              <InputNumber
                style={{ width: 100 }}
                value={updatedData[0]?.price}
                onChange={(value) => {
                  let newData = [...updatedData];
                  newData[0] = {
                    ...newData[0],
                    price: value,
                  };
                  setUpdatedData(newData);
                }}
              />
            </Col>
          </Row>
          <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
            <Col span={12}>
              <Space>
                <div>{"for next "}</div>
                <InputNumber
                  style={{ width: 100 }}
                  value={updatedData[1]?.duration}
                  onChange={(value) => {
                    let newData = [...updatedData];
                    newData[1] = {
                      ...newData[1],
                      duration: value,
                    };
                    setUpdatedData(newData);
                  }}
                />
                <div>{"min"}</div>
              </Space>
            </Col>
            <Col span={12}>
              <InputNumber
                style={{ width: 100 }}
                value={updatedData[1]?.price}
                onChange={(value) => {
                  let newData = [...updatedData];
                  newData[1] = {
                    ...newData[1],
                    price: value,
                  };
                  setUpdatedData(newData);
                }}
              />
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <div>{`for duration > ${
              updatedData[0]?.duration + updatedData[1]?.duration
            }, per min price `}</div>
            <InputNumber
              style={{ width: 100, marginLeft: 15 }}
              value={updatedPPMin}
              onChange={(value) => {
                setUpdatedPPMin(value);
              }}
            />
          </div>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => {
                setUpdatedData(null);
              }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleUpdate}>
              {"Save"}
            </Button>
          </Space>
        </Modal>
      ) : null}
    </div>
  );
}

export default PriceModal;
